// src/constants/adminConfig.js
// ============================================================
// SUPER ADMIN CONFIGURATION
// ============================================================
// Central configuration for super admin privileges.
// Super admins can view ALL breweries, kegs, taps, locations, etc.
// across the entire system regardless of membership.

/**
 * Super admin email address
 * This user can see all data across all breweries
 */
export const SUPER_ADMIN_EMAIL = 'bryce.brewer92@gmail.com';

/**
 * Brewery name where super admin should appear in member lists
 * Super admin will be hidden from all other brewery member lists
 */
export const SUPER_ADMIN_HOME_BREWERY = 'Brewer Born';

/**
 * Check if the given email belongs to a super admin
 * @param {string} email - User email to check
 * @returns {boolean} True if user is a super admin
 */
export const isSuperAdmin = (email) => {
  if (!email) return false;
  return email.toLowerCase() === SUPER_ADMIN_EMAIL.toLowerCase();
};

/**
 * Check if super admin should be visible in a brewery's member list
 * @param {string} breweryName - Name of the brewery
 * @returns {boolean} True if super admin should be shown in this brewery's member list
 */
export const shouldShowSuperAdminInBrewery = (breweryName) => {
  if (!breweryName) return false;
  return breweryName.toLowerCase() === SUPER_ADMIN_HOME_BREWERY.toLowerCase();
};
